import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ThreadCard from "./ThreadCard";

export default function ThreadList({threads, openThread}) {
  return (
    <Container style={{background: '#efefff'}}>
      <Box pt={3} pb={2}>
        <Typography variant='h4'>スレッド一覧</Typography>
      </Box>
      <List>
      {
        threads.slice().reverse().map((item) => {
          return (
            <ThreadCard
              title={item.title}
              description={item.description}
              creator={item.creator}
              date={item.date}
              onClick={() => openThread(item.threadId)}
            />
          );
        })
      }
      </List>
    </Container>
  );
}
